package com.sweetlime.bingeamigo.presentation.components

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Bookmark
import androidx.compose.material.icons.outlined.BookmarkBorder
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import com.sweetlime.bingeamigo.model.LibraryMovie
import com.sweetlime.bingeamigo.presentation.ui.BrandColors
import com.sweetlime.bingeamigo.presentation.features.library.LibraryViewModel
import org.koin.compose.viewmodel.koinViewModel

@Composable
fun WatchlistButton(
    libraryMovie: LibraryMovie,
    libraryViewModel: LibraryViewModel = koinViewModel(),
) {
    val watchlist by libraryViewModel.watchlist.collectAsState()
    val uiState by libraryViewModel.uiState.collectAsState()
    val isAdded = watchlist.any { it.id == libraryMovie.id }
    var isLoading by remember { mutableStateOf(false) }

    LaunchedEffect(isAdded) { isLoading = false }
    LaunchedEffect(uiState) {
        if (uiState is com.sweetlime.bingeamigo.state.LibraryUiState.Error) {
            isLoading = false
            libraryViewModel.clearError()
        }
    }

    Button(
        modifier = Modifier.fillMaxWidth(),
        onClick = {
            if (isLoading) return@Button
            isLoading = true
            if (isAdded) {
                libraryViewModel.removeFromWatchlist(libraryMovie)
            } else {
                libraryViewModel.addToWatchlist(libraryMovie)
            }
        },
        colors = if (isAdded)
            ButtonDefaults.buttonColors(containerColor = BrandColors.Secondary, contentColor = Color.White)
        else
            ButtonDefaults.buttonColors(containerColor = Color.Transparent, contentColor = Color.White),

        border = if (!isAdded) BorderStroke(1.dp, Color.White.copy(alpha = 0.4f)) else null
    ) {
        when {
            isLoading -> CircularProgressIndicator(
                modifier = Modifier.size(18.dp),
                strokeWidth = 2.dp,
                color = Color.White
            )
            isAdded -> Row(modifier = Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {
                Icon(imageVector = Icons.Filled.Bookmark, contentDescription = null)
                Spacer(modifier = Modifier.width(6.dp))
                Text("In Watchlist")
            }
            else -> Row(modifier = Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {
                Icon(imageVector = Icons.Outlined.BookmarkBorder, contentDescription = null)
                Spacer(modifier = Modifier.width(6.dp))
                Text("Add to Watchlist")
            }
        }
    }
}